import { store } from './store';
import userAuthActions from '../services/auth/actions';

const boot = () =>
  new Promise(() => {
    store.dispatch(userAuthActions.getUserAuthData());
    store.dispatch(userAuthActions.getRefreshToken());
  });

export default boot;
